<oe-modal [title]="'GENERAL.PRODUCTION'| translate" *ngIf="isInitialized">

    <!-- total summary of AC + DC -->
    <ng-container *ngIf="productionMeters?.length > 0 && chargerComponents?.length > 0">
        <oe-modal-line [name]="'GENERAL.TOTAL'| translate" channelAddress="_sum/ProductionActivePower"
            [converter]="CONVERT_TO_WATT">
        </oe-modal-line>
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
    </ng-container>

    <!-- ProductionMeters -->
    <ng-container *ngIf="productionMeters?.length === 1">
        <ng-container *ngFor="let meter of productionMeters; let i = index">
            <oe-electricity-meter [component]="meter"></oe-electricity-meter>
            <oe-modal-horizontal-line></oe-modal-horizontal-line>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="productionMeters.length > 1">
        <oe-modal-line margin_bottom="2" [converter]="CONVERT_TO_WATT"
            [name]="('GENERAL.TOTAL'| translate) + (chargerComponents.length > 0 ? '&nbsp;AC':'')"
            [channelAddress]="'_sum/ProductionAcActivePower'">
        </oe-modal-line>
        <oe-modal-line *ngFor="let phase of ['L1','L2','L3']" [textIndent]="TextIndentation.SINGLE"
            [name]=" ('GENERAL.PHASE'| translate) + '&nbsp;' + phase"
            [channelAddress]="'_sum/ProductionAcActivePower' + phase" [converter]="CONVERT_TO_WATT">
        </oe-modal-line>
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
        <ng-container *ngFor="let meter of productionMeters; let i = index">
            <oe-electricity-meter [component]="meter"></oe-electricity-meter>
            <oe-modal-horizontal-line [index]="i" [components]="productionMeters">
            </oe-modal-horizontal-line>
        </ng-container>
        <oe-modal-horizontal-line *ngIf="chargerComponents.length > 0"></oe-modal-horizontal-line>
    </ng-container>

    <!-- Chargers -->
    <ng-container *ngIf="chargerComponents.length > 1">
        <oe-modal-line [name]="('GENERAL.TOTAL'| translate) + (productionMeters.length > 0 ? '&nbsp;DC':'')"
            [channelAddress]="'_sum/ProductionDcActualPower'" [converter]="CONVERT_TO_WATT">
        </oe-modal-line>
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
    </ng-container>
    <ng-container *ngFor="let component of chargerComponents; let i = index">
        <oe-ess-charger [component]="component"></oe-ess-charger>
        <oe-modal-horizontal-line [index]="i" [components]="chargerComponents"></oe-modal-horizontal-line>
    </ng-container>

    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.PHASES_INFO' | translate">
    </oe-modal-info-line>
</oe-modal>
